import StampField from './StampField';

export default StampField;
